import {createActions} from 'client/framework';

export default createActions(null, [
  'COMMIT_CORRECTION_CHANGE',
  'REMOVE_ACTIVE_OPTION_CORRECTION',
  'SET_ACTIVE_OPTION',
  'SET_INITIAL_CORRECTIONS'
]);
